<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 210.935"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="48.907"
            cy="95.753"
            r="9.965"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthLeft}"
            @click="select('fourthLeft')"
            d="M25.564 37.196c6.29,-2.089 13.17,-2.283 20.055,-0.657 -1.125,-9.961 -2.042,-20.85 -2.75,-32.669 -10.554,-0.312 -15.783,0.874 -17.052,10.306 -0.809,6.005 -0.717,15.098 -0.253,23.02z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M48.735 59.063c-5.342,0.513 -11.312,2.907 -17.819,7.202 0.007,0.019 0.014,0.037 0.021,0.055 1.477,3.778 3.184,6.943 5.028,9.613 3.108,4.503 6.015,8.054 11.711,8.568 6.756,0.61 13.659,-6.802 18.481,-17.975 -3.143,-3.834 -6.872,-6.217 -11.123,-7.136 -1.988,-0.43 -4.089,-0.54 -6.299,-0.327z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M45.602 36.534c0.91,8.15 1.956,15.686 3.133,22.529 2.21,-0.213 4.311,-0.103 6.299,0.327 1.139,-3.654 1.833,-11.02 2.014,-21.917 0.145,-8.795 -0.043,-19.889 -0.602,-33.191 -1.458,0.052 -2.871,0.082 -4.16,0.021 -3.521,-0.166 -6.652,-0.351 -9.417,-0.433 0.047,0.786 0.095,1.567 0.144,2.345 0.687,10.918 1.556,21.026 2.606,30.324 -0.005,-0.002 -0.011,-0.003 -0.017,-0.005z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdLeft}"
            @click="select('thirdLeft')"
            d="M48.735 59.063c-1.177,-6.843 -2.223,-14.379 -3.133,-22.529 -6.879,-1.621 -13.753,-1.425 -20.038,0.662 0.235,4.013 0.566,7.725 0.925,10.583 0.93,7.414 2.478,13.486 4.427,18.486 6.507,-4.295 12.477,-6.689 17.819,-7.202z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthRight}"
            @click="select('fourthRight')"
            d="M57.04 24.643c0.061,4.287 0.074,8.671 0.006,12.861 5.259,-1.105 9.429,-1.263 15.94,0.158 1.358,-11.05 1.528,-21.157 -1.381,-29.578 -1.609,-4.656 -8.812,-4.026 -15.155,-3.802 0.312,7.478 0.507,14.273 0.59,20.361z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdRight}"
            @click="select('thirdRight')"
            d="M55.034 59.39c4.251,0.919 7.98,3.302 11.123,7.136 0.463,-1.072 0.907,-2.18 1.33,-3.319 1.707,-4.599 3.069,-9.702 3.955,-15.061 0.591,-3.57 1.124,-7.072 1.544,-10.484 -6.511,-1.421 -10.681,-1.263 -15.94,-0.158 -0.151,9.32 -0.701,17.682 -2.012,21.886z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M71.442 48.146c2.503,-15.131 3.971,-29.041 0.163,-40.062 -1.98,-5.728 -12.425,-3.455 -19.319,-3.781 -16.96,-0.801 -24.868,-2.03 -26.469,9.873 -1.218,9.047 -0.394,25.104 0.672,33.603 1.637,13.051 5.188,21.943 9.476,28.154 3.108,4.503 6.015,8.054 11.711,8.568 10.025,0.905 20.376,-15.855 23.766,-36.355zm-3.955 15.061c-0.394,30.107 -0.545,63.652 -5.274,104.145 -3.178,27.219 -11.105,33.197 -16.098,14.47 -3.443,-12.914 -4.294,-31.192 -4.224,-43.506 -0.503,-23.486 -3.829,-46.462 -10.954,-71.996"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="47.944"
            cy="197.22"
            r="9.965"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
